export class NativeArchivoDto {
    constructor(file) {
        this.file = file;
        this.lastModified = file.lastModified;
        this.lastModifiedDate = file.lastModifiedDate;
        this.name = file.name;
        this.size = file.size;
        this.type = file.type;
    }

}